<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import BasicButton from '~/components/form-elements/BasicButton.vue'
import RussianPostInternationalParcel from '~/components/modal-windows/shipping/RussianPostInternationalParcel.vue'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const props = defineProps<{
  promoCodeName: string | null
}>()

async function openRussianPostInternationalParcelModalWindow (): Promise<void> {
  const { promoCodeName } = props
  const appliedPromoCodeName = cartStore.isPromoCodeApplied && promoCodeName ? promoCodeName : null

  await useModal({ component: RussianPostInternationalParcel, attrs: { appliedPromoCodeName } }).open()
}
</script>

<template>
  <div>
    <template v-if="cartStore.shippingData">
      <Notification v-if="cartStore.shippingCostInKopecks === null" class="my-6" is-small status="warning">
        Извините, EMS Почта России не&nbsp;доставляет в&nbsp;выбранную страну. Напишите в&nbsp;службу поддержки для оформления заказа по&nbsp;вашему адресу.
      </Notification>
      <Notification v-else class="my-6" is-small status="info">
        Выбранная страна: {{ cartStore.shippingData.countryName }}.
      </Notification>
    </template>
    <Notification v-else class="my-6" is-small status="info">
      Выберите страну и&nbsp;узнайте стоимость доставки.
    </Notification>

    <BasicButton
      color="body-background"
      :title="cartStore.shippingData ? 'Изменить страну' : 'Выбрать страну'"
      @click="openRussianPostInternationalParcelModalWindow"
    />
  </div>
</template>
